import React, { useContext } from 'react';
import ThemeContext from '../theme_context';
import ThemeProvider from '../theme_provider';
import { jsx as ___EmotionJSX } from "@emotion/core";
function invertedMode(mode) {
  if (mode === 'light') return 'dark';
  if (mode === 'dark') return 'light';
  return mode;
}
function InvertedTheme(props) {
  var {
    children
  } = props;
  var {
    mode
  } = useContext(ThemeContext);
  return ___EmotionJSX(ThemeProvider, {
    mode: invertedMode(mode)
  }, children);
}
export default InvertedTheme;